import { render, staticRenderFns } from "./AMNeon80.vue?vue&type=template&id=12c96dc5&scoped=true"
import script from "./AMNeon80.vue?vue&type=script&lang=ts"
export * from "./AMNeon80.vue?vue&type=script&lang=ts"
import style0 from "./AMNeon80.vue?vue&type=style&index=0&id=12c96dc5&prod&lang=scss&scoped=true"
import style1 from "./AMNeon80.vue?vue&type=style&index=1&id=12c96dc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c96dc5",
  null
  
)

export default component.exports